module.exports = __webpack_public_path__ + "static/letter-734440380c9e7bc173fddc2eed9e659a.png";